import React from 'react'

export function UiComSectionWr(props) {
    
    return (
        <>
            <div className='sba-com-section' {...props}/> 
        </>
    )
}

export function UiComTopSection(props) {
    const { title, amount } = props;
    return (
        <>
            <div className='sba-com-section__top'>
                <h3>{title}</h3>
                <span>{amount}</span>
            </div>
            
        </>
    )
}

export function UiCommunicationRow(props) {
    const { date, heading, onClick } = props;
    return (
        <>
            <div className='sba-com-section__row'>
                <span>{date}</span>
                <span>{heading}</span>
                <span onClick={onClick} className='sba-com-view-btn'>View</span>
            </div>
            
        </>
    )
}

export function UiCommunicationInboundRow(props) {
    const { name, state, onClick } = props;
    return (
        <>
            <div className='sba-com-section__row'>
                <span className='sba-com-section__name'>{name}</span>
                {state == "pending" && <span className='sba-com-section__pending'>Pending</span>}
                {state == "complete" && <span className='sba-com-section__complete'>Complete</span>} 
                <span onClick={onClick} className='sba-com-view-btn'>View</span>
            </div>
            
        </>
    )
}
